export default __webpack_public_path__ + "static/media/arrowMobile.a2d24088.svg";